import styled from "styled-components";
import { motion } from "framer-motion";

export const Wrap = styled.div`
  display: flex;
  justify-content: space-around;
  position: relative;
`;
export const Step = styled.div`
  width: 30px;
  height: 30px;
  margin: 0 8px;
  color: white;
  position: relative;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-primary);
  box-shadow: 0px 6px 26px -5px rgba(102, 26, 136, 0.5);
  user-select: none;
`;

export const ActiveStep = motion(styled.div`
  z-index: 10;
  position: absolute;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  top: -1px;
  left: -1px;
  background-color: var(--color-cta);
`);
